export function classNames(...classes: string[]): string {
  return classes.filter(Boolean).join(" ");
}

export const Class = {
  classNames,
};

export default Class;
